import { render, staticRenderFns } from "./DouYinReceiveRecords.vue?vue&type=template&id=6b6a10dc&scoped=true"
import script from "./DouYinReceiveRecords.vue?vue&type=script&lang=js"
export * from "./DouYinReceiveRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6a10dc",
  null
  
)

export default component.exports